import React from "react";
import "./App.css";
import CustomCursor from "./components/CustomCursor";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Skills from "./components/Skills";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Contact from "./components/Contact";

export default function App() {
  return (
    <div className="app-container">
      <CustomCursor />
      <div className="noise-overlay"></div>
      <div className="ambient-orbs">
        <div className="orb orb-1"></div>
        <div className="orb orb-2"></div>
        <div className="orb orb-3"></div>
      </div>
      
      <Navbar />
      <main className="main-content">
        <Hero />
        <About />
        <Skills />
        <Experience />
        <Projects />
        <Contact />
      </main>
      
      <footer className="footer" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
        <p>&copy; {new Date().getFullYear()} Prasad Nallajala. Crafted with precision.</p>
        <img src="https://komarev.com/ghpvc/?username=prasad-portfolio-main&color=4f46e5&label=PROFILE+VIEWS&style=flat" alt="Profile Views" />
      </footer>
    </div>
  );
}
